import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordLoggedOutResetComponent } from './password-logged-out-reset.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';

@NgModule({
    declarations: [PasswordLoggedOutResetComponent],
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        SharedModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
    ],
    exports: [
        PasswordLoggedOutResetComponent,
        CommonModule,
        BrowserModule,
        FormsModule,
    ],
})
export class PasswordLoggedOutResetModule {}
